/**
 * 缩放
 */
import app from './app.js';

export const Zoom = function(canvas) {
	this.listener = canvas
	this.scaling = 1
	this.step = 0.03
	this.maxScale = 5
	this.minScale = 0.2
}

Zoom.prototype.setScale = function(val) {

	this.scaling =  val
	$('.scaleValue').html((this.scaling.toFixed(2)*100).toFixed(0)+'%')
	app.model.setScale(val)
}

Zoom.prototype.setStep = function(val) {
	this.step =  val
}

Zoom.prototype.setMaxScale = function(val) {
	this.maxScale = val
}

Zoom.prototype.setMinScale = function(val) {
	this.minScale = val
}

Zoom.prototype._addEvent = function(obj, sType, fn) {
    if (obj.addEventListener) {
        obj.addEventListener(sType, fn, false);
    } else {
        obj.attachEvent('on' + sType, fn);
    }
};

Zoom.prototype._removeEvent = function(obj, sType, fn) {
    if (obj.removeEventListener) {
        obj.removeEventListener(sType, fn, false);
    } else {
        obj.detachEvent('on' + sType, fn);
    }
};

Zoom.prototype._prEvent = function(ev) {
    let oEvent = ev || window.event;
    if (oEvent.preventDefault) {
        oEvent.preventDefault();
    }
    return oEvent;
}

Zoom.prototype._addWheelEvent = function(obj, callback) {
	let _this = this
    if (window.navigator.userAgent.toLowerCase().indexOf('firefox') != -1) {
        this._addEvent(obj, 'DOMMouseScroll', wheel);
    } else {
        this._addEvent(obj, 'mousewheel', wheel);
    }
    function wheel(ev) {
        let oEvent = _this._prEvent(ev),
        delta = oEvent.detail ? oEvent.detail > 0 : oEvent.wheelDelta < 0;
        callback && callback.call(oEvent, delta);
        //return false;
    }
};

/**
 * 绑定滚轮控制缩放操作
 * @param  object 	listener  监听滑轮滚动操作的对象
 * @param  array 	targets   要变化的对象数组
 */
Zoom.prototype.bindZoom = function(listener, canvas, targets, callback) {
	let _this = this
    this._addWheelEvent(listener, function(delta) {
		$('.enlarge').removeClass('forbid');
		$('.narrow').removeClass('forbid');
        if (!delta) {
            if ( _this.maxScale * 10 - (_this.scaling * 10).toFixed(1) < _this.step * 10) {
		    	_this.setScale(_this.maxScale)
				$('.enlarge').addClass('forbid');
		    } else {
		    	_this.setScale(_this.scaling += _this.step)
		    }
        } else if(delta) {
            if ((_this.scaling * 10).toFixed(1) - _this.minScale * 10 < _this.step * 10) {
	            _this.setScale(_this.minScale)
				$('.narrow').addClass('forbid');
		    } else {
		    	_this.setScale(_this.scaling -= _this.step)
		    }
        }
        let pos = document.querySelector('.edit_box').getBoundingClientRect(),
        	left = this.clientX - pos.x,
        	top = this.clientY - pos.y;

       	let ratioL = (left - (canvas.offsetLeft+canvas.offsetWidth/2)) / canvas.offsetWidth,
	        ratioT = (top - (canvas.offsetTop+canvas.offsetHeight/2)) / canvas.offsetHeight,
	        w = parseInt(canvas.width * _this.scaling),
	        h = parseInt(canvas.height * _this.scaling),
	        l = 0,
	        t = 0;

	    if (ratioL > 0 && ratioT > 0) {
	    	l = canvas.offsetLeft - (w - canvas.offsetWidth)
	    	t = canvas.offsetTop - (h - canvas.offsetHeight)
	    } else if (ratioL > 0) {
	    	l = canvas.offsetLeft - (w - canvas.offsetWidth)
	    	t = canvas.offsetTop
	    } else if (left < canvas.offsetLeft - canvas.offsetWidth/2) {
	    	l = canvas.offsetLeft + (w - canvas.offsetWidth)
	    	t = canvas.offsetTop
	    } else if (ratioT > 0) {
	    	l = canvas.offsetLeft
	    	t = canvas.offsetTop - (h - canvas.offsetHeight)
	    } else if (top < canvas.offsetTop - canvas.offsetHeight/2) {
	    	l = canvas.offsetLeft
	    	t = canvas.offsetTop + (h - canvas.offsetHeight)
	    } else {
	    	l = Math.round(left - (w *  (left - canvas.offsetLeft) / canvas.offsetWidth) )
	    	t = Math.round(top - (h * (top - canvas.offsetTop) / canvas.offsetHeight))
	    }
       	
       	targets.forEach( item => {
       		item.style.width = w +'px';
	        item.style.height = h +'px';
	        item.style.left = l +'px';
	        item.style.top = t +'px';
       	})
       	
       	if (callback)
       		callback(w, h, l, t)
    });
	listener.addEventListener('touchstart',function(event){
		var store = {
			scale : 1
		};
		var touches = event.touches;
		var events = touches[0];//单指
		var events2 = touches[1];//双指
		// 第一个触摸点的坐标
		store.pageX = events.pageX;
		store.pageY = events.pageY;
		store.moveable = true;
		if (events2) {
			store.pageX2 = events2.pageX;
			store.pageY2 = events2.pageY;
		}
		store.originScale = store.scale || 1;
		function startMove(event){
			var touches = event.touches;
			var events = touches[0];
			var events2 = touches[1];
			if (events2) {
				// 第2个指头坐标在touchmove时候获取
				if (!store.pageX2) {
					store.pageX2 = events2.pageX;
				}
				if (!store.pageY2) {
					store.pageY2 = events2.pageY;
				}

				// 获取坐标之间的距离
				var getDistance = function(start, stop) {
				//用到三角函数
					return Math.hypot(stop.x - start.x,
							stop.y - start.y);
				};
				// 双指缩放比例计算
				var zoom = getDistance({
					x : events.pageX,
					y : events.pageY
				}, {
					x : events2.pageX,
					y : events2.pageY
				}) / getDistance({
					x : store.pageX,
					y : store.pageY
				}, {
					x : store.pageX2,
					y : store.pageY2
				});
				// 应用在元素上的缩放比例
				$('.enlarge').removeClass('forbid');
				$('.narrow').removeClass('forbid');
				var newScale = store.originScale * zoom;
				if(newScale>store.scale){
					if ( _this.maxScale * 10 - (_this.scaling * 10).toFixed(1) < _this.step * 10) {
						_this.setScale(_this.maxScale)
						$('.enlarge').addClass('forbid');
					} else {
						_this.setScale(_this.scaling += _this.step)
					}
				}else{
					if ((_this.scaling * 10).toFixed(1) - _this.minScale * 10 < _this.step * 10) {
						_this.setScale(_this.minScale)
						$('.narrow').addClass('forbid');
					} else {
						_this.setScale(_this.scaling -= _this.step)
					}
				}
				let pos = document.querySelector('.edit_box').getBoundingClientRect(),
					left = (events2.pageX-events.pageX)/2+events.pageX - pos.x,
					top = (events2.pageY-events.pageY)/2+events.pageY - pos.y;
				   let ratioL = (left - (canvas.offsetLeft+canvas.offsetWidth/2)) / canvas.offsetWidth,
					ratioT = (top - (canvas.offsetTop+canvas.offsetHeight/2)) / canvas.offsetHeight,
					w = parseInt(canvas.width * _this.scaling),
					h = parseInt(canvas.height * _this.scaling),
					l = 0,
					t = 0;
		
				if (ratioL > 0 && ratioT > 0) {
					l = canvas.offsetLeft - (w - canvas.offsetWidth)
					t = canvas.offsetTop - (h - canvas.offsetHeight)
				} else if (ratioL > 0) {
					l = canvas.offsetLeft - (w - canvas.offsetWidth)
					t = canvas.offsetTop
				} else if (left < canvas.offsetLeft - canvas.offsetWidth/2) {
					l = canvas.offsetLeft + (w - canvas.offsetWidth)
					t = canvas.offsetTop
				} else if (ratioT > 0) {
					l = canvas.offsetLeft
					t = canvas.offsetTop - (h - canvas.offsetHeight)
				} else if (top < canvas.offsetTop - canvas.offsetHeight/2) {
					l = canvas.offsetLeft
					t = canvas.offsetTop + (h - canvas.offsetHeight)
				} else {
					l = Math.round(left - (w *  (left - canvas.offsetLeft) / canvas.offsetWidth) )
					t = Math.round(top - (h * (top - canvas.offsetTop) / canvas.offsetHeight))
				}
				   
				   targets.forEach( item => {
					   item.style.width = w +'px';
					item.style.height = h +'px';
					item.style.left = l +'px';
					item.style.top = t +'px';
				   })
				   
				   if (callback)
					   callback(w, h, l, t)

				store.scale = newScale;
			}
		}
		function endMove(){
			listener.removeEventListener('touchmove',startMove);
			listener.removeEventListener('touchend',endMove);
		}
		if(event.touches.length==2){
			listener.addEventListener('touchmove',startMove)
			listener.addEventListener('touchend',endMove);
		}
	})
}

/**
 * 点击放大
 * @param  elementObj  btn  
 * @param  zoomObj     listener 
 */
Zoom.prototype.bindClickZoomIn = function(btn, listener, targets, callback) {
	let _this = this
	for(var i=0;i<btn.length;i++){
		btn[i].onclick = function () {
			$('.enlarge').removeClass('forbid');
			$('.narrow').removeClass('forbid');
			if ( _this.maxScale * 10 - (_this.scaling * 10).toFixed(1) < _this.step * 10) {
				_this.setScale(_this.maxScale)
				this.classList.add('forbid');
			} else {
				_this.setScale(_this.scaling += _this.step)
			}
			
			let w = parseInt(listener.width * _this.scaling),
				h = parseInt(listener.height * _this.scaling),
				l = Math.round(listener.offsetLeft - listener.style.width * (_this.scaling - 1) / 2),
				t = Math.round(listener.offsetTop - listener.style.height * (_this.scaling - 1) / 2);
	
			targets.forEach( item => {
				   item.style.width = w +'px';
				item.style.height = h +'px';
				item.style.left = l +'px';
				item.style.top = t +'px';
			   })
			   
			   if (callback)
				   callback(w, h, l, t)
		}
	}
}

/**
 * 点击缩小
 * @param  elementObj  btn  
 * @param  zoomObj     listener 
 */
Zoom.prototype.bindClickZoomOut = function(btn, listener, targets, callback) {
	let _this = this
	for(var i=0;i<btn.length;i++){
		btn[i].onclick = function () {
			$('.enlarge').removeClass('forbid');
			$('.narrow').removeClass('forbid');
			if ((_this.scaling * 10).toFixed(1) - _this.minScale * 10 < _this.step * 10) {
				_this.setScale(_this.minScale)
				this.classList.add('forbid');
			} else {
				_this.setScale(_this.scaling -= _this.step)
			}
					
			let w = parseInt(listener.width * _this.scaling),
				h = parseInt(listener.height * _this.scaling),
				l = Math.round(listener.offsetLeft - listener.style.width * (_this.scaling - 1) / 2),
				t = Math.round(listener.offsetTop - listener.style.height * (_this.scaling - 1) / 2);
	
			targets.forEach( item => {
				   item.style.width = w +'px';
				item.style.height = h +'px';
				item.style.left = l +'px';
				item.style.top = t +'px';
			   })
			   
			   if (callback)
				   callback(w, h, l, t)
		}
	}
}